import { Link } from 'react-router-dom';
import { IconMail, IconMapPin, IconMessage, IconPhone } from '@/components/landing/LandingIcons';
import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/constants/routes';

const contactCards = [
  {
    title: 'Email Us',
    value: 'info@asdatalink.com',
    href: 'mailto:info@asdatalink.com',
    icon: IconMail,
    tone: 'orange' as const,
  },
  {
    title: 'Call Us',
    value: '+234 806 666 6663',
    href: 'tel:+2348066666663',
    icon: IconPhone,
    tone: 'green' as const,
  },
  {
    title: 'Location',
    value: 'Katsina, Nigeria',
    icon: IconMapPin,
    tone: 'orange' as const,
  },
  {
    title: 'WhatsApp',
    value: 'Chat with us',
    href: 'https://wa.me/2348066664224',
    icon: IconMessage,
    tone: 'green' as const,
  },
];

export function ContactSection() {
  return (
    <section id="contact" className="bg-brand-surface/50 py-20">
      <div className="container-page">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle mx-auto">Get In Touch</p>
          <p className="mt-2 text-sm text-brand-muted">
            Have questions or need assistance? We&apos;re here to help! Reach out to us through any of the channels below.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {contactCards.map((card) => {
            const content = (
              <>
                <div
                  className={`inline-flex rounded-xl p-3 ${
                    card.tone === 'orange' ? 'bg-primary/10 text-primary' : 'bg-secondary/10 text-secondary'
                  }`}
                >
                  <card.icon className="h-6 w-6" />
                </div>
                <h3 className="mt-4 font-bold text-brand-navy">{card.title}</h3>
                <p className="mt-1 text-sm text-brand-muted">{card.value}</p>
              </>
            );

            if (card.href) {
              return (
                <a
                  key={card.title}
                  href={card.href}
                  target={card.href.startsWith('http') ? '_blank' : undefined}
                  rel={card.href.startsWith('http') ? 'noreferrer' : undefined}
                  className="rounded-2xl border border-gray-100 bg-white p-6 shadow-soft transition hover:border-primary/30 hover:shadow-card"
                >
                  {content}
                </a>
              );
            }

            return (
              <div key={card.title} className="rounded-2xl border border-gray-100 bg-white p-6 shadow-soft">
                {content}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function CtaSection() {
  return (
    <section className="py-20">
      <div className="container-page rounded-3xl bg-gradient-brand px-8 py-14 text-center text-white shadow-card">
        <h2 className="text-3xl font-bold sm:text-4xl">Ready to Start?</h2>
        <p className="mx-auto mt-4 max-w-2xl text-white/90">
          Join thousands of satisfied customers who trust ASDATALINK for their daily digital transactions. Sign up now and enjoy the best rates in Nigeria!
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to={ROUTES.register}>
            <Button size="lg" className="bg-white text-primary hover:bg-white/90">
              Create Account
            </Button>
          </Link>
          <a
            href="https://wa.me/2348066664224"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-xl border border-white/40 bg-white/10 px-6 py-3 text-sm font-semibold text-white backdrop-blur hover:bg-white/20"
          >
            WhatsApp Us
          </a>
        </div>
      </div>
    </section>
  );
}
